import React from 'react';
import CountOfTotal from '../../../../../components/CountOfTotal';
import SelectForm from '../../../../../components/form/SelectForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Modal from '../../../../../components/Modal';
import InfoForm from '../../../../../components/outline/InfoForm';
import {
  MAXIMUM_NUMBER_OF_STORE_TAG_REJECT_REASON_TEXT,
  STORE_TAG_REJECT_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/brandConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './RejectRegistrationStoreTag.scss';

const RejectRegistrationStoreTag = (props) => {
  const { form, isOpen, closeModal, type, reason, onSubmit, setData } = props;

  return (
    <Modal
      title="브랜드 태그 승인 거절"
      isOpen={isOpen}
      width={600}
      height={300}
      isFooter={true}
      okText="브랜드 태그 승인 거절"
      overflow="hidden"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <InfoForm className="reject-registration-product-tag-modal">
        <SelectForm
          form={form}
          label="브랜드 태그 거절 타입"
          isTable
          rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
          initialValue={type}
          onChange={(value) => setData({ name: 'type', value })}
          list={STORE_TAG_REJECT_TYPE_SELECT_LIST}
          name="type"
        />

        <TextAreaForm
          form={form}
          label={
            <span>
              브랜드 태그 거절 사유
              <CountOfTotal content={reason} maxCnt={MAXIMUM_NUMBER_OF_STORE_TAG_REJECT_REASON_TEXT} />
            </span>
          }
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          initialValue={reason}
          maxLength={MAXIMUM_NUMBER_OF_STORE_TAG_REJECT_REASON_TEXT}
          onChange={(value) => setData({ name: 'reason', value })}
          name="reason"
          rows={6}
        />
      </InfoForm>
    </Modal>
  );
};

export default RejectRegistrationStoreTag;
